/**
 * Calculates ellipsoid (spheroid) volume in mL assuming:
 * - LD and SAD are semi-axes in centimeters (cm)
 * - using V = (4.2)·(((LD+SAD)/4)²)
 * Since 1 cm^3 = 1 mL, the numeric result equals mL.
 */

// tumorVolume.js (fixed for power = 2)
export function calculateTumorVolume(LD, SAD) {
  const LDD = Number(LD)
  const SADD = Number(SAD)

  if (!Number.isFinite(LDD) || !Number.isFinite(SADD)) return null
  if (LDD <= 0 || SADD <= 0) return null

  const volume = 4.2 * Math.pow((LDD + SADD) / 4, 3)
  return volume
}

export function formatNumber(value, decimals = 2) {
  if (!Number.isFinite(value)) return ""
  const factor = 10 ** decimals
  const rounded = Math.round((value + Number.EPSILON) * factor) / factor
  return rounded.toFixed(decimals)
}